export default "__VITE_ASSET__063b1f1f__"